module.exports = "<div v-bind:class=\"{'Check--error': error}\" class=Check><label v-if=fdata.label class=Check__label>{{{ fdata.label }}}</label><label :for=fdata.field class=Check__control><input :id=fdata.field type=checkbox :disabled=!fdata.editable v-model=formInput @change=validate class=Check__field /><div class=Check__indicator></div></label><div v-if=fdata.suffix class=\"Check__label Check__append\">{{{ fdata.suffix }}}</div></div>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/inputs/checkbox/checkbox.vue
// module id = 438
// module chunks = 0